import { selectFetchingExaminersDetail } from '../../../store/workspace/selectors';
import { resetExamStatistics } from '../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../store/store';
import Loading from '../../../components/Loading';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';

function JobsHistory() {
    const dispatch = useDispatch();
    const fetchingData = useSelector(selectFetchingExaminersDetail);

    useEffect(() => {
        return () => {
            dispatch(resetExamStatistics());
        }
    }, []);

    return (
        <>
            <Outlet />
            {fetchingData && <Loading />}
        </>
    )
};

export default JobsHistory;
